// extracted by mini-css-extract-plugin
module.exports = {"timssnackbar":"LsH_j","timssnackbarshow":"uT7KV","etimeslogo":"p9M5x","timsclosebtn":"Xu20y"};